<template>
  <v-container class="pt-5">
    <v-card class="mx-auto" max-width="800" fill-height>
      <v-card-title class="primary white--text headline justify-space-between">
        {{ currentTitle }}
        <v-avatar
          color="secondary"
          class="subheading white--text"
          size="24"
          v-text="step"
        ></v-avatar>
      </v-card-title>
      <v-layout column>
        <v-window v-model="step" touchless>
          <v-window-item :value="1">
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs12 sm4>
                  <v-subheader>{{ $t('select_service') }}</v-subheader>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-select
                    v-model="select"
                    :hint="
                      `${select.TechnicalSystemCode ||
                        '----'}, ${select.IdentCode || '----'}`
                    "
                    :items="items"
                    item-text="Name"
                    item-value="Id"
                    :label="$t('select_licence')"
                    persistent-hint
                    return-object
                    single-line
                  >
                    <template slot="selection" slot-scope="data">
                      {{
                        `${data.item.Name} ${$t('price')}: ${
                          data.item.PriceWithoutVat
                        } Kč`
                      }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="
                            `${data.item.Name}         ${$t('price')}:${
                              data.item.PriceWithoutVat
                            } Kč`
                          "
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="data.item.IdentCode"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-window-item>

          <v-window-item :value="2">
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="ecrs"
                    v-model="selected"
                    select-all
                    item-key="device_id"
                  >
                    <template v-slot:headers="props">
                      <tr>
                        <th>
                          <v-checkbox
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.stop="toggleAll"
                          ></v-checkbox>
                        </th>
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="[
                            'column sortable',
                            pagination.descending ? 'desc' : 'asc',
                            header.value === pagination.sortBy ? 'active' : ''
                          ]"
                          @click="changeSort(header.value)"
                        >
                          <v-icon small>arrow_upward</v-icon>
                          {{ header.text }}
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr
                        :active="props.selected"
                        @click="props.selected = !props.selected"
                      >
                        <td>
                          <v-checkbox
                            :input-value="props.selected"
                            primary
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td>{{ props.item.desc }}</td>
                        <td>{{ props.item.device.sn }}</td>
                        <td>{{ props.item.device.devicestatus.ecr1_fw }}</td>
                        <td>{{ props.item.device.devicestatus.ecr1_model }}</td>
                        <td>{{ props.item.device.devicestatus.version }}</td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="warning" icon="warning">
                        {{ $t('sorry_nothing') }}
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-window-item>

          <v-window-item :value="3">
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs12>
                  <Summary
                    :items="selected"
                    :price="[select.Name, select.PriceWithoutVat]"
                    @count="getProductTotalPrice"
                  ></Summary>
                  <v-divider dark></v-divider>
                  <v-layout row wrap xs12 md12>
                    <v-flex xs12 md3>
                      <span class="font-weight-bold headline">
                        {{ $t('summary') }}
                      </span>
                    </v-flex>
                    <v-flex xs12 md3>
                      <span>{{ $t('price_wo_vat') }}:</span>
                      <span class="pl-1 font-weight-bold headline">
                        {{ parseFloat(summary.PriceWithoutVat).toFixed(2) }}Kč
                      </span>
                    </v-flex>
                    <v-flex xs12 md3>
                      <span>{{ $t('price_with_vat') }}:</span>
                      <span class="pl-1 font-weight-bold headline">
                        {{ parseFloat(summary.PriceWithVat).toFixed(2) }}Kč
                      </span>
                    </v-flex>
                    <v-flex xs12 md3>
                      <span>{{ $t('vat_tariff') }}:</span>
                      <span class="pl-1 font-weight-bold headline"
                        >{{ summary.VatTariff }}%</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-checkbox v-model="terms">
                  <template v-slot:label>
                    {{ $t('terms') }}
                    <a
                      class="pa-1"
                      href="/api/conditions"
                      @click.stop
                      v-on="on"
                      >{{ $t('conditions') }}</a
                    >.
                  </template>
                  >
                </v-checkbox>
              </v-layout>
            </v-card-text>
          </v-window-item>

          <v-window-item :value="4">
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs12>
                  <div class="pa-3 text-xs-center">
                    <h2 class="display-2 font-weight-light mb-2">
                      {{ `${$t('payment')} id: ${rs.id} ` }}
                    </h2>
                    <p>
                      <span class="title">
                        {{ `${$t('order_no')}: ${rs.order_number}` }}
                      </span>
                    </p>
                    <p>
                      <span class="title">
                        {{
                          `${$t('amount')}: ${parseFloat(
                            rs.amount / 100
                          ).toFixed(2)} Kč`
                        }}
                      </span>
                    </p>
                    <p v-show="rs.hasOwnProperty('sub_state')">
                      <span class="title font-weight-light">{{
                        `${$t('sub_state')}: ${getSubState()}`
                      }}</span>
                    </p>
                    <p>
                      <span class="title">{{ showStatus() }}</span>
                    </p>
                    <p v-show="not_send" class="pl-1 font-weight-light">
                      {{ $t('mail_send') }}
                    </p>
                  </div>
                  <div v-show="rs.state === 'PAID'" class="pa-3 text-xs-center">
                    <span class="display-2 font-weight-light">
                      {{ $t('thanks') }}
                    </span>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-window-item>
        </v-window>
      </v-layout>
      <v-card-actions>
        <v-btn :disabled="step === 1 || step === 4" flat @click="step--">
          {{ $t('back') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-show="step == 4 && rs.state === 'PAID'"
          @click="downloadInvoice(rs.order_number)"
          >{{ $t('invoice') }}</v-btn
        >
        <v-spacer></v-spacer>
        <v-img
          v-show="step === 3"
          src="img/gopay.png"
          max-height="35"
          max-width="100"
          class="ma-2"
        ></v-img>
        <v-img
          v-show="step === 3"
          src="img/mastercard.png"
          max-height="35"
          max-width="156"
          class="ma-2"
        ></v-img>
        <v-img
          v-show="step === 3"
          src="img/visa.png"
          max-height="35"
          max-width="67"
          class="ma-2"
        ></v-img>

        <v-btn
          :disabled="
            (Object.keys(select).length === 0 && step === 1) ||
              (selected.length === 0 && step === 2) ||
              (selected.length === 0 && step === 3) ||
              (!terms && step === 3)
          "
          color="primary"
          depressed
          @click="stepUp"
          class
          >{{ buttonCaption() }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Summary from '@/components/Summary'
import substates from '@/components/sub_states.js'
export default {
  name: 'service-form',
  props: { query: null, busy: null },
  components: {
    Summary
  },

  data() {
    return {
      substates: substates,
      valid: false,
      step: 1,
      select: {},
      not_send: true,
      items: [{ IdentCode: '' }],
      headers: [
        {
          text: this.$t('ecr_name'),
          align: 'left',
          sortable: true,
          value: 'desc'
        },
        { text: this.$t('serial'), value: 'serial' },
        { text: this.$t('fw'), value: 'fw' },
        { text: this.$t('model'), value: 'model' },
        { text: this.$t('version'), value: 'version' }
      ],
      ecrs: [],
      pagination: {
        sortBy: 'name'
      },
      selected: [],
      rs: '',
      summary: {
        PriceWithoutVat: 'n/a',
        PriceWithVat: 'n/a',
        VatTariff: 'n/a'
      },
      terms: false
    }
  },
  methods: {
    initialize() {
      this.loadProducts()
    },
    update_busy(i) {
      // this.busy = i
      const d = i
      this.$emit('input', d)
    },

    stepUp() {
      if (this.step === 1) {
        this.getEcrsBuyable()
        this.step++
      } else if (this.step === 2) {
        this.getProductTotalPrice()
        this.step++
      } else if (this.step === 3) {
        this.pay_go()
      } else if (this.step === 4) {
        this.$router.push('/ecrmregistration')
      }
    },
    buttonCaption() {
      switch (this.step) {
        case 3:
          return this.$t('pay_order')
        case 4:
          return this.$t('back_to_ecr')
        default:
          return this.$t('next')
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.ecrs.slice()
    },
    async loadProducts() {
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(
          this.$providerURL + '/Api/Catalog/GetProductList'
        )
        this.items = res.data.Items
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async getProductTotalPrice() {
      if (this.selected.length === 0) {
        // this.$gerror({ Code: 905, Message: this.$('not_selected') })
        this.summary = {
          PriceWithoutVat: 0,
          PriceWithVat: 0,
          VatTariff: ''
        }
        return
      }
      this.$root.$loader(true)
      try {
        let res = await this.axios.post(
          this.$providerURL + '/Api/Catalog/GetProductTotalPrice',
          {
            Id: this.select.Id,
            Quantity: this.selected.length
          }
        )
        this.summary = res.data
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async getEcrsBuyable() {
      try {
        this.$root.$loader(true)
        let res = await this.axios.get(
          `/api/cashregister?canbuy=${this.select.IdentCode}`
        )
        this.ecrs = res.data
      } catch (e) {
        this.$root.$gerror(e.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    deleteEcrs() {
      this.ecrs = []
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    async getNewId() {
      let id = 0
      let r = await this.$http.get(this.$providerURL + '/Api/Access/GetNewId')
      id = r.data
      return id
    },
    getItems() {
      if (this.selected.length > 0) {
        let items = []
        for (let i of this.selected) {
          let item = {
            type: 'ITEM',
            name: `${this.select.IdentCode} ${i.device.sn}`,
            amount: Math.round(this.select.PriceWithoutVat * 1.21 * 100),
            count: 1,
            vat_rate: this.summary.VatTariff
          }
          items.push(item)
        }
        return items
      }
      return []
    },
    addParams() {
      return {
        name: 'sn',
        value: this.selected.map(x => x.device.sn).toString()
      }
    },
    async licenseCreate() {
      try {
        await this.axios.post(
          '/api/license/',
          this.selected.map(x => {
            let o = {}
            o.status = 10
            o.status_reason = 'web api'
            o.device_id = x.device_id
            o.name = this.select.IdentCode
            return o
          })
        )
      } catch (e) {
        if (e.response.data.Code !== 808) {
          throw e
        }
      }
    },
    async pay_go() {
      this.$root.$loader(true)
      localStorage.setItem('selected', JSON.stringify(this.selected))
      localStorage.setItem('select', JSON.stringify(this.select))
      localStorage.setItem('summary', JSON.stringify(this.summary))
      try {
        let id = await this.getNewId()
        if (id === 0) {
          throw 'No invoice id'
        }
        let res = await this.axios.post(`/api/create-payment/`, {
          amount: `${this.summary.PriceWithVat * 100}`,
          currency: 'CZK',
          order_number: id,
          order_description: `Platba licence ${this.select.Name}`,
          items: this.getItems(),
          additional_params: [
            // { name: 'invoicenumber', value: id },
            { name: 'user', value: this.$auth.user().Id.toString() },
            { name: 'productid', value: '' + this.select.Id.toString() },
            { name: 'productname', value: this.select.IdentCode.toString() },
            // { name: 'vattariff', value: this.summary.VatTariff.toString() },
            // {
            //   name: 'pricewithvat',
            //   value: this.summary.PriceWithVat.toString()
            // },
            // {
            //   name: 'pricewithoutvat',
            //   value: this.summary.PriceWithoutVat.toString()
            // },
            // { name: 'quantity', value: this.selected.length.toString() },
            this.addParams()
          ],
          payer: {
            contact: {
              first_name: this.$auth.user().UserFirstName,
              last_name: this.$auth.user().LastName,
              email: this.$auth.user().Email,
              phone_number: this.$auth.user().Phone,
              city: this.$auth.user().City,
              street: this.$auth.user().Street,
              postal_code: this.$auth.user().ZipCode,
              country_code: 'CZE'
            },
            allowed_payment_instruments: ['PAYMENT_CARD']
          },
          callback: {
            return_url: this.$uiURL + '/services_mgmt/',
            notification_url:
              this.axios.defaults.baseURL + '/api/notify-payment'
          }
        })
        await _gopay.checkout(
          { gatewayUrl: res.data.gw_url, inline: true },
          async result => {
            try {
              this.postPayment(result.id)
            } catch (error) {
              this.$root.$gerror(error.response.data)
            }
          }
        )
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async createInvoice() {
      try {
        await this.axios.post(
          this.$providerURL + '/Api/Invoice/CreateInvoice',
          {
            InvoiceId: this.rs.order_number,
            GoPayId: this.rs.id,
            ProductId: this.select.Id,
            Quantity: this.selected.length,
            PriceWithoutVat: this.summary.PriceWithoutVat,
            PriceWithVat: this.summary.PriceWithVat,
            VatTariff: this.summary.VatTariff,
            ItemExtCodes: this.selected.map(x => x.device.sn).toString()
          }
        )
      } catch (e) {
        if (e.response.data.Code !== 404) {
          throw e
        }
      }
    },
    async voidTransAction(rs) {
      try {
        let response = await this.axios.post('/api/payment-refund/', {
          id: rs.id,
          amount: rs.amount
        })
      } catch (error) {
        this.$root.$gerror(error.response.data)
      }
    },
    async postPayment(id) {
      this.not_send = true
      this.$root.$loader(true)
      try {
        this.update_busy(true)

        let rs = await this.axios.post('/api/get-payment-status/', {
          id: id
        })
        this.rs = rs.data

        this.step = 4
        switch (this.rs.state) {
          case 'PAID':
            try {
              await this.licenseCreate()
              await this.createInvoice()
            } catch (error) {
              if (error.response.data.Code === 406) {
                this.not_send = false
              } else {
                this.$root.$gerror(error.response.data)
              }
            }
            this.showStatus()
            break
          case 'CANCELED':
            this.showStatus()
            break
          case 'TIMEOUTED':
            this.showStatus()
            break
          case 'REFUNDED':
            this.showStatus()
            break
          case 'PARTIALY_REFUNDED':
            this.showStatus()
            break
          case 'AUTHORIZED':
            this.showStatus()
            break
          case 'PAYMENT_METHOD_CHOSEN':
            this.showStatus()
            break
          default:
            return
        }
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
        this.update_busy(false)
      }
    },
    showStatus() {
      let d = this.rs
      switch (d.state) {
        case 'PAID':
          return `proběhla v pořádku.`
        case 'CANCELED':
          return `byla zrušena.`
        case 'CREATED':
          return `nebyla provedena.`
        case 'TIMEOUTED':
          return `vypršel časový limit.`
        case 'REFUNDED':
          return `byla vrácena (Refundována).`
        case 'PARTIALY_REFUNDED':
          return `byla částečné vrácena.`
        case 'AUTHORIZED':
          return `byla autorizována.`
        case 'PAYMENT_METHOD_CHOSEN':
          return `byla vybrána platební metoda.`
        default:
          return
      }
    },
    getSubState() {
      if (this.rs.hasOwnProperty('sub_state')) {
        return this.substates[this.rs.sub_state]
      }
    },
    async downloadInvoice(id) {
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(
          `${this.$providerURL}/Api/Invoice/GetInvoiceDocument?invoiceId=${id}`
          // {
          //   responseType: 'arraybuffer',
          //   headers: {
          //     'Content-Type': 'application/json; charset=utf-8',
          //     Accept: 'application/json'
          //   }
          // }
        )
        await this.downLink(res.data)
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async downLink(data) {
      const file = data
      //Build a URL from the file
      // const fileURL = URL.createObjectURL(file)
      let link = document.createElement('a')
      link.href = `data:application/pdf;base64,${file}`
      link.download = `Faktura_${new Date().toLocaleDateString('cs-CS', {
        timeZone: 'Europe/Prague'
      })}.pdf`
      link.setAttribute('target', '_blank')
      link.setAttribute('download', link.download)
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  async mounted() {
    let script = document.createElement('script')
    script.setAttribute('src', 'https://gate.gopay.cz/gp-gw/js/embed.js')
    document.head.appendChild(script)
    this.initialize()
    if (this.$route.query.id) {
      this.selected = JSON.parse(localStorage.getItem('selected'))
      this.select = JSON.parse(localStorage.getItem('select'))
      this.summary = JSON.parse(localStorage.getItem('summary'))
      try {
        await this.postPayment(this.$route.query.id)
      } catch (error) {
        this.$root.$gerror(error.response.data)
      }
    }
  },
  created() {},
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          this.deleteEcrs()
          return this.$t('choose_service')
        case 2:
          return this.$t('select_ecrs')
        case 3:
          return this.$t('summary')
        default:
          return this.$t('result')
      }
    },
    disabled() {
      if (this.step === 2 && this.selected.length < 1) {
        return true
      }
      return false
    },
    bussiness() {
      return this.busy ? this.busy : false
    }
  }
}
</script>

<style></style>
